export default {
  header: {
    title: "BOIRES [bwaʁ] n.m. : Slang, néologisme, nom commun inspiré du mot anglais drinks. Dans notre jargon populaire, on l’utilise pour désigner des boissons désaltérantes, notamment les vins de notre agence"
  },
  left: {
    title: 'COMPAGNIE',
    p1: 'Boires, c’est une équipe de passionnés de vin et de gastronomie. Nous sommes en recherche constante, nous explorons des régions rurales afin de découvrir des vins et d’autres produits issus d’un environnement où la nature triomphe.',
    p2: 'L’agence a été fondée en 2013 avec l’objectif de représenter des producteurs artisanaux, pour les présenter aux amateurs de vins, qu’ils soient des particulier ou des professionnels. Notre travail nous emmène à développer les marchés de l’Ontario et du Québec.'
  },
  right: {
    title: 'MISSION',
    p1: 'Nous œuvrons à faire découvrir le fruit du travail d’artisans doués provenant de régions reconnues ou émergentes.',
    p2: 'Notre sélection de produits reflète la vision et les valeurs de notre entreprise : promouvoir l’authenticité et le respect de l’environnement, tout en gardant le cap sur un marché des alcools en constante évolution.',
    p3: 'Nous privilégions les producteurs soucieux d’offrir un produit unique qui se démarque des best-sellers génériques.'
  },
  contactUs: {
    title: "CONTACTEZ NOUS",
    first: "Prénom",
    last: "Nom",
    email: "Courriel",
    subject: "Sujet",
  },
  address1: {
    title: "MONTRÉAL",
    desc: '5258 avenue du Parc <br> Montréal (Qc) H2V 4G7 <br> Canada',
  },
  address2: {
    title: "QUÉBEC",
    desc: '281 rue de la Couronne <br> Quebec, QC - G1K 6E2',
  },
  address3: {
    title: "TORONTO",
    desc: '1583 Dupont St, Toronto <br> Toronto, ON, M6P 3S5',
  },
  form: {
    checkbox: 'Je ne suis pas un robot',
    button: 'Envoyer'
  }
}
